
namespace TabAurous.Scheme {

    @Serenity.Decorators.registerClass()
    export class SchemeMasterDialog extends Serenity.EntityDialog<SchemeMasterRow, any> {
        protected getFormKey() { return SchemeMasterForm.formKey; }
        protected getIdProperty() { return SchemeMasterRow.idProperty; }
        protected getLocalTextPrefix() { return SchemeMasterRow.localTextPrefix; }
        protected getNameProperty() { return SchemeMasterRow.nameProperty; }
        protected getService() { return SchemeMasterService.baseUrl; }
        protected getDeletePermission() { return SchemeMasterRow.deletePermission; }
        protected getInsertPermission() { return SchemeMasterRow.insertPermission; }
        protected getUpdatePermission() { return SchemeMasterRow.updatePermission; }

        protected form = new SchemeMasterForm(this.idPrefix);

        constructor() {
            super();
            q.setTextRightAlign(this.form.SchemeAmount);
            q.setTextRightAlign(this.form.BonusValue);
            q.setTextRightAlign(this.form.Tenure);
            q.setTextRightAlign(this.form.CancellationCharge);
        }
    }
}